var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_3200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 17.499H6.086L0.045 11.458C0.016 11.799 0 12.148 0 12.499C6.5391e-05 15.5085 1.1309 18.408 3.16833 20.6229C5.20575 22.8377 8.00102 24.2062 11 24.457V17.499Z",
    fill: "#4A72FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1261 19.6247C18.4509 18.9533 17.9154 18.1549 17.5505 17.2754C17.1856 16.3959 16.9985 15.4529 17.0001 14.5007H13.0001C12.2045 14.5007 11.4414 14.1846 10.8788 13.622C10.3162 13.0594 10.0001 12.2964 10.0001 11.5007V8.50071H13.0001V4.50071H17.0861L18.9001 2.68371C17.343 1.5898 15.548 0.881917 13.6633 0.618475C11.7787 0.355033 9.85836 0.543592 8.06094 1.16859C6.26352 1.79358 4.6405 2.83709 3.32587 4.21299C2.01123 5.58888 1.04267 7.2577 0.500122 9.08171L6.91412 15.5007H10.0001C10.7958 15.5007 11.5588 15.8168 12.1214 16.3794C12.6841 16.942 13.0001 17.7051 13.0001 18.5007V24.4587C15.9281 24.2165 18.6648 22.906 20.6891 20.7767L19.1261 19.6247Z",
    fill: "#4A72FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.489 18.1581L21.943 19.2201C23.5094 16.9023 24.2167 14.1101 23.9429 11.3261C23.669 8.5421 22.431 5.94126 20.443 3.97314L17.914 6.50114H15V10.5011H12V12.5011H19V14.4911C19.0042 15.8599 19.5378 17.1739 20.489 18.1581Z",
    fill: "#4A72FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_3200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourLearning);
export default __webpack_public_path__ + "static/media/yourLearning.a507ce8a48044842d96bc5480ec7adbb.svg";
export { ForwardRef as ReactComponent };